<script>
  import solicitacaoPagamentoServico from '../../servico';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import formasPagamento from '~js/formas-pagamento';
  import tiposPagamento from '~js/tipos-pagamento';
  import tiposDocumento from '../tipos-documento';
  import tiposConta from '~js/tipos-conta';
  import tiposPessoaConta from '~js/tipos-pessoa-conta';
  import tiposPix from '~js/tipos-pix';
  import tiposQuadro from '~js/tipos-quadro';
  import Barcode from '@xkeshi/vue-barcode';

  export default {
    components: { Cabecalho, Barcode },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        formasPagamento: formasPagamento,
        tiposPagamento: tiposPagamento,
        tiposDocumento: tiposDocumento,
        tiposConta: tiposConta,
        tiposPessoaConta: tiposPessoaConta,
        tiposPix: tiposPix,
        tiposQuadro: tiposQuadro,
        configuracao: this.$storage.configuracao(),
        classificacoesEmpresa: [
          { id: 1, nome: 'MEI' },
          { id: 2, nome: 'ME' },
          { id: 3, nome: 'EPP' },
          { id: 4, nome: 'SA' },
          { id: 5, nome: '3º setor' },
          { id: 6, nome: 'Pública' },
        ],
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoPagamentoServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          });
      },
      formaPagamento(id) {
        return this.formasPagamento.find(f => {
          return f.id === id;
        });
      },
      tipoPagamento(id) {
        return this.tiposPagamento.find(t => {
          return t.id === id;
        });
      },
      tipoDocumento(id) {
        return this.tiposDocumento.find(t => {
          return t.id === id;
        });
      },
      tipoConta(id) {
        return this.tiposConta.find(t => {
          return t.id === id;
        });
      },
      tipoPessoaConta(id) {
        return this.tiposPessoaConta.find(t => {
          return t.id === id;
        });
      },
      tipoPix(id) {
        return this.tiposPix.find(t => {
          return t.id === id;
        });
      },
      tipoQuadro(id) {
        return this.tiposQuadro.find(t => {
          return t.id === id;
        });
      },
      classificacaoEmpresa(id) {
        return this.classificacoesEmpresa.find(c => c.id === id);
      },
    },
    computed: {
      periodoDeVigencia() {
        let dataInicio = this.solicitacao.rateio.projeto.dataInicioVigencia;
        let dataTermino = this.solicitacao.rateio.projeto.dataTerminoVigencia;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }

        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }

        return periodo;
      },
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacao.liberacaoCoordenador) || '---';
      }
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Pagamento de Pessoa Jurídica - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-pagamento-pj';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              
              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                <cabecalho :titulo="'Solicitação de Pagamento de Pessoa Jurídica'"></cabecalho>

                <h3 class="m-t-none m-b">Dados da solicitação</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-8">
                    <dt>Projeto</dt>
                    <dd>{{ solicitacao.rateio.projeto ? solicitacao.rateio.projeto.nomeProjeto : '' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Tipo de projeto</dt>
                    <dd>{{ solicitacao.rateio.projeto.tipoProjeto ? solicitacao.rateio.projeto.tipoProjeto.nome : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Período de vigência</dt>
                    <dd>{{ periodoDeVigencia }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Nr. processo</dt>
                    <dd>{{ solicitacao.rateio.projeto ? solicitacao.rateio.projeto.nrProcesso : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.idSolicitacao || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Data da solicitação</dt>
                    <dd>{{ solicitacao.dataSolicitacao | formatarNumeroEmDataExtenso }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Solicitante</dt>
                    <dd>{{ solicitacao.solicitante ? solicitacao.solicitante.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Coordenador do projeto</dt>
                    <dd>{{ solicitacao.rateio.projeto.coordenador ? solicitacao.rateio.projeto.coordenador.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Data de liberação do coordenador</dt>
                    <dd>{{ dataLiberacaoCoordenador }}</dd>
                  </dl>
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Liberado por</dt>
                    <dd>{{ solicitacao.liberadoPor ? solicitacao.liberadoPor.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Nº protocolo</dt>
                    <dd>{{ solicitacao.protocolo ? solicitacao.protocolo.numeroProtocolo : '---'}}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Código de barras protocolo</dt>
                    <dd><barcode :value="solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                  </dl>
                </div>

                <div class="row" v-if="configuracao.utilizarDetalheRateioSolicitacao">
                  <dl class="col-xs-12">
                    <dt>Detalhe rateio</dt>
                    <dd>{{ solicitacao.rateio.detalheRateio ? solicitacao.rateio.detalheRateio.nome : '---'}}</dd>
                  </dl>
                </div>

                <div class="row" v-if="configuracao.selecaoDeContaWeb">
                  <dl class="col-xs-12">
                    <dt>Conta</dt>
                    <dd>{{ solicitacao.conta ? solicitacao.conta.nome : '---' }}</dd>
                  </dl>
                </div>

                <div class="row" v-if="solicitacao.rateio.projeto.utilizarMetaEtapaProjeto">
                  <dl class="col-xs-12">
                    <dt>Meta Etapa</dt>
                    <dd>{{ solicitacao.rateio.projetoMetaEtapa.meta ? solicitacao.rateio.projetoMetaEtapa.meta.nome : '' }} - {{ solicitacao.rateio.projetoMetaEtapa.etapa ? solicitacao.rateio.projetoMetaEtapa.etapa.nome : '' }}</dd>
                  </dl>
                </div>

                <div class="row" v-if="configuracao.exibirRubricaSubrubricaSolicitacaoWeb || solicitacao.rateio.projeto.utilizarRubricaSubrubricaWeb">
                  <dl class="col-xs-6">
                    <dt>Rubrica</dt>
                    <dd>{{ solicitacao.rubrica ? solicitacao.rubrica.nome : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-6">
                    <dt>Subrubrica</dt>
                    <dd>{{ solicitacao.subrubrica ? solicitacao.subrubrica.nome : '---'}}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Dados cadastrais</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-8">
                    <dt>Nome</dt>
                    <dd>{{ solicitacao.nomeTerceiro || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>CNPJ</dt>
                    <dd>{{ solicitacao.documentoTerceiro || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Inscrição estadual</dt>
                    <dd>{{ solicitacao.identidade || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-6">
                    <dt>Inscrição municipal</dt>
                    <dd>{{ solicitacao.inscricaoMunicipal || '---' }}</dd>
                  </dl>
                </div>

                <div class="row" v-if="configuracao.solicitacaoPJPermitirPgtoContaPF">
                  <dl class="col-xs-4">
                    <dt>CPF do sócio majoritário</dt>
                    <dd>{{ solicitacao.cpfSocioMajoritario || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Classificação da empresa</dt>
                    <dd>{{ classificacaoEmpresa(solicitacao.classificaEmpresa) ? classificacaoEmpresa(solicitacao.classificaEmpresa).nome : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Utiliza conta do sócio</dt>
                    <dd>{{ solicitacao.utilizarContaDoSocio == null ? '---' : (solicitacao.utilizarContaDoSocio == 1 ? 'Sim' : 'Não') }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Endereço</dt>
                    <dd>{{ solicitacao.endereco || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.numero || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Complemento</dt>
                    <dd>{{ solicitacao.complemento || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Bairro</dt>
                    <dd>{{ solicitacao.bairro || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Cidade</dt>
                    <dd>{{ solicitacao.cidade || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Estado</dt>
                    <dd>{{ solicitacao.uf || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>CEP</dt>
                    <dd>{{ solicitacao.cep || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Telefone 1</dt>
                    <dd>{{ solicitacao.telefoneResidencial || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Telefone 2</dt>
                    <dd>{{ solicitacao.telefoneComercial || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Fax</dt>
                    <dd>{{ solicitacao.fax || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>E-mail do beneficiário</dt>
                    <dd>{{ solicitacao.emailTerceiro || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Dados para o pagamento</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row" v-if="solicitacao.compraDireta">
                  <dl class="col-xs-12">
                    <dt>Este pagamento é uma compra direta</dt>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-lg-3" v-if="configuracao.exibirDataPgtoSolicitacaoPgto">
                    <dt>Data para pagamento</dt>
                    <dd>{{ solicitacao.dataPagamento | formatarNumeroEmData }}</dd>
                  </dl>

                  <dl :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-3' : 'col-lg-4']">
                    <dt>Forma de pagamento</dt>
                    <dd>{{ formaPagamento(solicitacao.formaPagamento) ? formaPagamento(solicitacao.formaPagamento).nome : '--' }}</dd>
                  </dl>

                  <dl :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-3' : 'col-lg-4']">
                    <dt>Tipo pagamento</dt>
                    <dd>{{ tipoPagamento(solicitacao.tipoPagamento) ? tipoPagamento(solicitacao.tipoPagamento).nome : '--' }}</dd>
                  </dl>

                  <dl :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-3' : 'col-lg-4']">
                    <dt>Valor (R$)</dt>
                    <dd>{{ solicitacao.rateio.valorRateio }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Tipo documento</dt>
                    <dd>{{ tipoDocumento(solicitacao.tipoDocumento) ? tipoDocumento(solicitacao.tipoDocumento).nome : '--' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Nº do Documento/Nota</dt>
                    <dd>{{ solicitacao.notaFiscal || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Data de emissão</dt>
                    <dd>{{ solicitacao.dataEmissao | formatarNumeroEmData('---') }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Data de vencimento</dt>
                    <dd>{{ solicitacao.dataVencimento | formatarNumeroEmData('---') }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Atividade/descrição serviços</dt>
                    <dd class="white-space-pre">{{ solicitacao.observacao || '---' }}</dd>
                  </dl>
                </div>

                <div v-if="solicitacao.formaPagamento === 0">
                  <h3 class="m-t-none m-b">Dados bancários</h3>

                  <div class="hr-line-dashed margin-top-5"></div>

                  <div class="row" v-if="solicitacao.tipoConta != 4">
                    <dl class="col-xs-3">
                      <dt>Banco</dt>
                      <dd>{{ solicitacao.banco || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>Agência</dt>
                      <dd>{{ solicitacao.agencia || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Conta</dt>
                      <dd>{{ solicitacao.contaCorrente || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Tipo de conta</dt>
                      <dd>{{ tipoConta(solicitacao.tipoConta) ? tipoConta(solicitacao.tipoConta).nome : '--' }}</dd>
                    </dl>

                    <dl class="col-xs-2" v-if="configuracao.solicitacaoPJPermitirPgtoContaPF">
                      <dt>Tipo de pessoa</dt>
                      <dd>{{ tipoPessoaConta(solicitacao.tipoPessoa) ? tipoPessoaConta(solicitacao.tipoPessoa).nome : '--' }}</dd>
                    </dl>
                  </div>

                  <div class="row" v-if="solicitacao.tipoConta == 4">
                    <dl class="col-xs-3">
                      <dt>Tipo pix</dt>
                      <dd>{{ tipoPix(solicitacao.tipoPix) ? tipoPix(solicitacao.tipoPix).nome : '--' }}</dd>
                    </dl>

                    <dl class="col-xs-9">
                      <dt>Chave PIX</dt>
                      <dd>{{ solicitacao.chavePix || '---' }}</dd>
                    </dl>
                  </div>
                </div>

                <h3 class="m-t-none m-b" v-if="configuracao.solicitacaoPJAnexarNF || configuracao.solicitacaoPJAnexarBoleto || solicitacao.solicitacaoPJJustificativaEmissaoNF">Arquivos anexados:</h3>

                <div class="hr-line-dashed margin-top-5" v-if="configuracao.solicitacaoPJAnexarNF || configuracao.solicitacaoPJAnexarBoleto || solicitacao.solicitacaoPJJustificativaEmissaoNF"></div>

                <div class="row" v-if="solicitacao.solicitacaoPJJustificativaEmissaoNF">
                  <dl class="col-xs-12">
                    <dt>Justificativa da emissão da nota fiscal acima de 30 dias</dt>
                    <dd class="white-space-pre">{{ solicitacao.solicitacaoPJJustificativaEmissaoNF }}</dd>
                  </dl>
                </div>

                <div class="row" v-if="configuracao.solicitacaoPJAnexarNF">
                  <dl class="col-xs-2">
                    <dt>Anexou a nota fiscal?</dt>
                    <dd>{{ solicitacao.solicitacaoPJAnexouNF == null ? '---' : solicitacao.solicitacaoPJAnexouNF == 'true' ? 'Sim' : 'Não' }}</dd>
                  </dl>

                  <dl class="col-xs-3" v-if="solicitacao.solicitacaoPJAnexouNF == 'false'">
                    <dt></dt>
                    <dd style="padding-top: 15px;">Me comprometo a inserir a nota fiscal no Sistema Manager após o recebimento do produto.</dd>
                  </dl>

                  <dl class="col-xs-7" v-if="solicitacao.solicitacaoPJAnexouNF == 'false'">
                    <dt>Justificar o motivo de não ter inserido a nota fiscal</dt>
                    <dd>{{ solicitacao.solicitacaoPJJustificativaNF }}</dd>
                  </dl>
                </div>
                <div class="row" v-if="configuracao.solicitacaoPJAnexarBoleto  && solicitacao.formaPagamento === 3">
                    <dl class="col-xs-2">
                        <dt>Anexou o boleto dentro do vencimento?</dt>
                        <dd>{{ solicitacao.solicitacaoPJAnexouBoleto == null ? '---' : solicitacao.solicitacaoPJAnexouBoleto == 'true' ? 'Sim' : 'Não'
                      }}
                    </dd>
                    </dl>

                    <dl class="col-xs-10" v-if="false">
                        <dt></dt>
                        <dd style="padding-top: 15px;">Texto que compromete enviar Boleto</dd>
                    </dl>
                </div>

                <div class="hr-line-dashed margin-top-5" v-if="this.configuracao.solPagamentoPJMsgConfirmacao"></div>

                <div class="row" v-if="this.configuracao.solPagamentoPJMsgConfirmacao">
                  <div class="col-md-12">
                    <p><i>{{this.configuracao.solPagamentoPJMsgConfirmacao}}</i></p>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento/juridica/componentes/SolicitacaoPagamentoRelatorio.vue